import React, { Component } from 'react';
import 'core-js/es6/symbol';
import 'core-js/fn/array/from';
import 'core-js/es6/weak-map';
require('core-js/es6/object');
require('core-js/es6/map');

class ValidatingImageInput extends Component {

    constructor(props) {
        super(props);
        this.handleImageChange = this.handleImageChange.bind(this);
        this.showUploadError = this.props.showUploadError.bind(this);
        this.handleImageTooLarge = this.handleImageTooLarge.bind(this);
        this.handleServerError = this.handleServerError.bind(this);
		this.deleteImage = this.deleteImage.bind(this);
        this.state = {
            file: '',
            imagePreviewUrl: '',
			deleteImageError: false
        };
    }

    handleImageError(blobUrl, fname) {
        URL.revokeObjectURL(blobUrl);
        //TODO display error - selected file was not a valid image
        let msg = `File '${fname}' is not a supported Image format, or has been damaged or corrupted. Please upload a JPEG, PNG, or GIF image.`;
        this.showUploadError(msg);
    }

    handleImageTooLarge(size, fname) {
        this.showUploadError(`Sorry, max upload size is 12 MB, but '${fname}' is ${size} MB`);
    }

    handleServerError(json) {
        this.showUploadError(`We had a problem saving your upload.  Please proceed to the next step.`);
    }

    handleImageChange(e) {
        e.preventDefault();

        this.setState({
            file: null,
            imagePreviewUrl: ""
        });

        let reader = new FileReader();
        let file = e.target.files[0];
        let contentTP = file ? file.type : "";	// type determined based solely on file name extension, see https://developer.mozilla.org/en-US/docs/Web/API/File/type
        let orderId = this.props.gearOrder.id;
        let type = this.props.type;

        /* Verify that the user-selected upload fits expected file signatures
         *
         * Img type   Magic number in hex
         * --------   -------------------
         * JPEG       FF D8...FF D9   (start...end)
         * GIF87a     47 49 46 38 37 61
         * GIF89a     47 49 46 38 39 61
         * PNG        89 50 4E 47 0D 0A 1A 0A
         */

        const KB = 1024,
            MB = KB * KB,
            validExts = ['gif', 'jpg', 'jpeg', 'png'],
            headers = {
                'jpeg': [0xFF, 0xD8, 0xFF, 0xD9],
                'gif-87a': [0x47, 0x49, 0x46, 0x38, 0x37, 0x61],
                'gif-89a': [0x47, 0x49, 0x46, 0x38, 0x39, 0x61],
                'png': [0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A]
            };

        reader.onloadend = () => {

            // enforce max file size
            if (reader.result.byteLength > 12 * MB) {
                this.handleImageTooLarge(parseInt(reader.result.byteLength / MB * 100, 10) / 100, file.name);
                reader = null;
                return;
            }

            let userImgBlob = new Blob([reader.result]),
                userImgBlobUrl = URL.createObjectURL(userImgBlob),
                extension = file.name.split('.').pop().toLowerCase(),
                byteArray = Array.from(new Uint8Array(reader.result)),
                match = false,
                format;

            for (let key of Object.keys(headers)) {
                let hdrBytes = headers[key],
                    snip = key === 'jpeg' ? // check first and last 2 bytes of JPEG, only initial bytes for others
                        byteArray.slice(0, 2).concat(byteArray.slice(byteArray.length - 2))
                        : byteArray.slice(0, hdrBytes.length);

                for (let j in hdrBytes) {
                    if (hdrBytes[j] !== snip[j]) {
                        break;
                    }
                    if (Number(j) === hdrBytes.length - 1) {
                        match = true;
                        format = key;
                    }
                }
            }

            if (match && format && validExts.indexOf(extension) > -1 && contentTP === 'image/' + format.split('-')[0]) {

                // add image to canvas
                let canvas = document.createElement('canvas'),
                    ctx = canvas.getContext('2d'),
                    img = new Image(),
                    uploadMime = 'image/jpeg';

                img.onerror = () => {
                    this.handleImageError(userImgBlobUrl, file.name);
                }

                img.onload = () => {
                    URL.revokeObjectURL(userImgBlobUrl);
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0);

                    // look for transparent pixels and make them white
                    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height),
                        buf = new ArrayBuffer(imageData.data.length),
                        buf8 = new Uint8ClampedArray(buf),
                        buf32 = new Uint32Array(buf),
                        order = this.isLittleEndian() ? [3,2,1,0] : [0,1,2,3];

                    for (let n = 0; n < imageData.data.length; n += 4) {
                        if (imageData.data[n + 3] < 255) {
                            buf32.set([0xffffffff], n / 4); // white, fully opaque (as RGBA or ABGR, depending on endianness)
                        } else {
                            /*eslint-disable */
                            buf32.set([
                                imageData.data[n + order[0]] << 24
                                | imageData.data[n + order[1]] << 16
                                | imageData.data[n + order[2]] << 8
                                | imageData.data[n + order[3]]
                            ], n / 4);
                            /*eslint-enable */
                        }
                    }
                    imageData.data.set(buf8);
                    ctx.putImageData(imageData, 0, 0);

                    // export image from canvas as a JPEG and upload to server
                    canvas.toBlob((uploadImgBlob) => {

                        fetch(process.env.REACT_APP_GEAR_REST_URL +
                            '/uploadInsuranceAttachment?orderId=' + orderId +
                            '&cardImgType=' + type, {
                                method: 'POST',
                                credentials: 'include',
                                headers: {
                                    "Content-Type": uploadMime
                                },
                                body: uploadImgBlob
                            })
                            .then(response => response.json())
                            .then(json => {

                                if (json.orderId === orderId + ''
                                    && json.action === 'saveUpload'
                                    && json.type === type
                                    && json.result === 'success') {

                                    this.setState({
                                        file: file,
                                        imagePreviewUrl: URL.createObjectURL(uploadImgBlob),
										deleteImageError: false
                                    });
                                    console.log('Wow! Much upload, very success!')
									this.props.addUploadedImage(this.props.type, this.state.file.name);
                                } else {
                                    this.handleServerError(json);
                                }
                            });

                    }, uploadMime, 0.80);
                }
                // trigger img.onload, canvas import/export, and upload to server (or img.onerror if image data is invalid)
                img.src = userImgBlobUrl;

            } else {
                this.handleImageError(userImgBlobUrl, file.name);
            }
        }

        if (file) {
            reader.readAsArrayBuffer(file);
        }
    };

    isLittleEndian() {
        var buf = new ArrayBuffer(4);
        new Uint8Array(buf).set([0xAA, 0xBB, 0xCC, 0xDD]);
        return new Uint32Array(buf)[0] === 0xDDCCBBAA;
    }
	
	deleteImage() {
		fetch(process.env.REACT_APP_GEAR_REST_URL +
			'/deleteInsuranceAttachment?orderId=' + this.props.gearOrder.id +
			'&cardImgType=' + this.props.type, {
				method: 'DELETE',
				credentials: 'include'
			})
			.then(response => {
				this.setState({
					deleteImageError: !response.ok
				});
				if (response.ok) {
					this.props.removeUploadedImage(this.props.type);
					this.setState({
						imagePreviewUrl: null
					});
				}
			});
	};

    render() {
        let { imagePreviewUrl } = this.state;
        let imagePreview = null;
		let deleteImageErrorMessage = this.state.deleteImageError
			? <div><span className="alert-danger">An error occurred deleting this ID card.</span></div>
			: null;
		let uploadInput = this.props.gearOrder.attachments[this.props.type]
			? null
			: <input
				className="form-control img-input"
				type="file"
				style={{height: 'auto'}}
				id={this.props.type}
				onChange={(e) => this.handleImageChange(e)}
				accept="image/gif, image/jpeg, image/png" />;
		let uploadedFile = this.props.gearOrder.attachments[this.props.type]
			? <div>
				{this.props.gearOrder.attachments[this.props.type].name}
				<button type="button" className="btn btn-edit btn-danger" title="Delete image" onClick={this.deleteImage}>
					Delete
				</button>
				{deleteImageErrorMessage}
			  </div>
			: null;
		

        if (imagePreviewUrl) {
            imagePreview = (<img src={imagePreviewUrl} alt="preview" />);
        }

        return (
	            <div className="form-group">
	            	<label htmlFor={this.props.type}>{this.props.label}</label>
					{uploadInput}
					{uploadedFile}
	                <span className="previewComponent">
	                    <span className="imgPreview" hidden={!imagePreviewUrl}>
	                        {imagePreview}
	                    </span>
	                </span>
	            </div>
        )
    }
}
export default ValidatingImageInput;
